import { FC } from 'react';
import { HeroConversationMessage } from '@vs-online-only-app/state';
import ParticipantMessage from './ParticipantMessage';

type Props = {
  message: HeroConversationMessage;
};

const DepartmentSelectedMessage: FC<Props> = ({ message }) => {
  return (
    <ParticipantMessage message={message}>
      Selected department: <strong>{message.body}</strong>
    </ParticipantMessage>
  );
};

export default DepartmentSelectedMessage;
